if (!customElements.get('size-guide-drawer')) {
  customElements.define(
    'size-guide-drawer',
    class SizeGuideDrawer extends HTMLElement {
      connectedCallback() {
        this.drawer = this.querySelector('.size-guide__drawer');
        this.overlay = this.querySelector('.size-guide__overlay');
        this.trigger = this.querySelector('[data-sg-open]');
        this.unit = 'in';

        this.trigger.addEventListener('click', () => this.open());
        this.overlay.addEventListener('click', () => this.close());
        this.drawer.querySelectorAll('[data-sg-close]').forEach((el) =>
          el.addEventListener('click', () => this.close())
        );
        this.drawer.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.close();
        });
        this.drawer.querySelectorAll('[data-sg-unit]').forEach((button) =>
          button.addEventListener('click', () => this.setUnit(button.dataset.sgUnit))
        );

        // The product section animates in with a CSS transform, which turns any
        // position: fixed descendant into a section-relative box. Reparenting to
        // <body> keeps the drawer anchored to the viewport.
        document.body.append(this.overlay, this.drawer);
      }

      disconnectedCallback() {
        this.overlay.remove();
        this.drawer.remove();
        document.body.classList.remove('size-guide-open');
      }

      open() {
        this.drawer.classList.add('is-open');
        this.overlay.classList.add('is-open');
        document.body.classList.add('size-guide-open');
        this.drawer.focus({ preventScroll: true });
      }

      close() {
        this.drawer.classList.remove('is-open');
        this.overlay.classList.remove('is-open');
        document.body.classList.remove('size-guide-open');
        this.trigger.focus({ preventScroll: true });
      }

      setUnit(unit) {
        if (unit === this.unit) return;
        this.unit = unit;

        this.drawer.querySelectorAll('[data-sg-unit]').forEach((button) => {
          const active = button.dataset.sgUnit === unit;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active);
        });

        this.drawer.querySelectorAll('[data-sg-in]').forEach((cell) => {
          const inches = cell.dataset.sgIn;
          cell.textContent = unit === 'in' ? inches : this.toCm(inches);
        });
      }

      // Converts an inch value to cm, preserving ranges like "42-44".
      toCm(value) {
        return value
          .split('-')
          .map((part) => {
            const number = parseFloat(part);
            if (Number.isNaN(number)) return part;
            return String(Math.round(number * 2.54 * 10) / 10);
          })
          .join('-');
      }
    }
  );
}
